// extracted by mini-css-extract-plugin
export default {"link":"ListItem_link__bYfpn","title":"ListItem_title__6wVoi","details":"ListItem_details__z7ayM","button":"ListItem_button__PmPjz"};